import React from 'react';

import * as CatalogueSearch from '@/core/components/CatalogueSearch';
import Icons from '@/core/components/Icons';
import SchemaOrg from '@/core/components/SchemaOrg';
import { useComponentsContext } from '@/core/lib/components/components.context';
import { useNativeContext } from '@/core/lib/native/native.context';
import Store from '@/core/lib/new-architecture/store';
import { useRouterContext } from '@/core/lib/router/router.context';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import ItemList from '@/core/pages/Catalogue/ItemList';
import type { PageWithLayoutsAndProviders } from '@/core/pages/page.types';

const Catalogue: PageWithLayoutsAndProviders = () => {
  const { t } = useTranslationContext(['common', 'catalogue']);
  const { isNative } = useNativeContext();
  const { Page, Content, MetaTitle } = useComponentsContext();

  const { data: catalogue, next, isLoading, total, notFound } = Store.catalogue.useCatalogue();

  const { onGlobalNotFound } = useRouterContext();

  if (notFound && !isLoading) {
    onGlobalNotFound?.();
    return;
  }

  return (
    <>
      {catalogue && (
        <>
          <MetaTitle meta={catalogue.seo} />
          <SchemaOrg schema={catalogue.getBreadcrumbListSchema(t)} />
        </>
      )}

      <Page noPadding>
        {isNative && (
          <div className="sticky top-safe-top z-50 flex w-full bg-bg-primary px-4">
            <div className="flex w-full py-4">
              <CatalogueSearch.CatalogueSearchButton />
            </div>
          </div>
        )}
        <Content scroll={total > 0 ? catalogue?.getRoute().resolve() : undefined}>
          <div className={isNative ? 'px-4' : ''}>
            <CatalogueSearch.CatalogueSearchRecapSeo />
          </div>

          {isLoading && (
            <div aria-label={t('spinner.aria-valuetext', { ns: 'catalogue' })} className="flex h-screen items-center justify-center">
              <Icons icon="spinner" size="40" color="button-default" />
            </div>
          )}

          {!isLoading && catalogue?.donations && <ItemList donations={catalogue.donations} search={catalogue.search} next={next} />}

          {!isNative && (
            <>
              <CatalogueSearch.CatalogueSeoText />
              <div className="mb-20 mt-5 pb-safe-bottom">
                <CatalogueSearch.CataloguePagination total={total} />
              </div>
            </>
          )}
        </Content>
      </Page>

      {isNative && <CatalogueSearch.CatalogueSearchDialog />}
    </>
  );
};

export default Catalogue;
